export default {
  props: {
    courseData: {
      required: true,
      type: Object
    },
    termName: {
      type: String
    }
  }
};